package nl.astraeus.wiki.service

import nl.astraeus.wiki.WikiData
import nl.astraeus.wiki.domain.WikiListDto
import nl.astraeus.wiki.encoding.Tokenizer
import nl.astraeus.wiki.mainView
import nl.astraeus.wiki.messages.GetWikiListMessage
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.ws.WebsocketConnection

object WikiService {

  fun retrieveWikiList() {
    WebsocketConnection.send(GetWikiListMessage()) { response ->
      if (response.getMessageType() == MessageType.WIKI_LIST) {
        WikiData.wikiList.clear()
        val dtos = response.getBody().lines()

        for (dtoLine in dtos) {
          if (dtoLine.isNotBlank()) {
            val dto = WikiListDto(Tokenizer(dtoLine))

            WikiData.wikiList.add(dto)
          }
        }

        mainView.requestUpdate()
      }
    }
  }


}